import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import { addModal } from "../../../../../app.logic";
import { createFieldRadioGroup } from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import { modalStyleForm } from "../../../../../utils/constant";
import { initUseForm } from "../../../../../utils/form";
import { createLoading } from "../../../../../utils/loading";
import { required, validateError } from "../../../../../utils/validate";
import { callRequestStatus } from "../request.section";

export const { isLoading, setIsLoading } = createLoading();

export const ConfirmApproveForm = defineAsyncComponent(() => import("./ConfirmApproveForm"));

export const openModalForm = ({ props, onOk, bind }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okButtonProps: { disabled: false },
                title: i18n.global.t("views.request.modal.approve.title"),
                width: "500px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <ConfirmApproveForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
            ></ConfirmApproveForm>
        )
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {
        refStatus: null
    };
};

export const createRules = () => {
    return {
        refStatus: [required]
    };
};

export const createField = ({ data }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    return [
        createFieldRadioGroup({
            key: "refStatus",
            colProp: () => ({ xs: 24 }),
            formItemProp: () => ({ labelCol: { xs: 24 }, wrapperCol: { xs: 24 } }),
            inputProp: () => {
                return {
                    value: modelRef.refStatus,
                    "onUpdate:value": value => (modelRef.refStatus = value),
                    list: ({ searchQuery }) =>
                        callRequestStatus({ searchQuery }).then(items => {
                            const result = [];
                            const reEditAuthority = items.find(item => item.key === "reEditAuthority");
                            const approve = items.find(item => item.key === "approve");
                            const notApprove = items.find(item => item.key === "notApprove");
                            if (approve) result.push(approve);
                            if (reEditAuthority) result.push(reEditAuthority);
                            if (notApprove) result.push(notApprove);
                            return result;
                        }),
                    optLabel: "attribute.actionText",
                    type: "vertical"
                };
            }
        })
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
